<template>
  <div>
    <el-table
      :data="pendingList.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100 pending-table"
      stripe
      v-loading="loading"
    >
      <el-table-column width="100">
        <template #header>
          <el-checkbox @change="toggleSelectAll" class="checkbox-channel"></el-checkbox>
          <span>
            {{ selectedAllChannels ? pendingList.total : selectedChannels.length }} / {{ pendingList.total || 0 }}
          </span>
        </template>
        <template #default="props">
          <el-checkbox :label="props.row.channelId" :value="props.row.channelId"
                       v-model="selectedChannels" class="checkbox-channel"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column width="100%">
        <template slot-scope="props">
          <img
            v-if="props.row.image_url"
            class="avatar"
            :src="props.row.image_url"
          />
          <img
            v-else
            class="avatar"
            :src="`https://syncvault.com/static/apple-touch-icon.png`"
          />
        </template>
      </el-table-column>
      <el-table-column label="Channel">
        <template slot-scope="props">
          {{ props.row.title }}<br>
          ID: {{props.row.channelId}}
        </template>
      </el-table-column>
      <el-table-column label="Added" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column
          label="Requested By"
          prop="requester.email"
          sortable
      ></el-table-column>
      <el-table-column label="Requested" prop="requested_at" sortable>
        <template slot-scope="props">
          {{ props.row.requested_at | datetime }}
        </template>
      </el-table-column>
      <el-table-column label="Requested Action" prop="status" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.status === 2" type="success">
            Insert
          </el-tag>
          <el-tag v-else-if="props.row.status === 3" type="danger">
            Delete
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Review" placement="top">
            <el-button
              type="info"
              circle
              size="small"
              icon="el-icon-edit"
              @click="review(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @current-change="currentChange"
      :current-page.sync="pendingList.current_page"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="pendingList.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      selectedChannels: []
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', [
      'pendingList',
      'loading',
      'order_column',
      'order_type',
      'page_size',
      'selectedAllChannels'
    ])
  },

  watch: {
    selectedChannels(newVal) {
      this.setSelectedChannels(newVal)
    }
  },

  methods: {
    ...mapMutations('youtubeWhitelist', [
        'setPage', "setDialogReview", "setSelectedRequest", 'setSelectedChannels', 'setSelectedAllChannels'
    ]),
    ...mapActions('youtubeWhitelist', ['readPendingList', 'destroy']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readPendingList()
    },
    review(row) {
      this.setDialogReview(true)
      this.setSelectedRequest(row)
    },

    toggleSelectAll(value) {
      if (value) {
        this.selectedChannels = this.pendingList.data.map(_ => _.channelId)
        this.setSelectedAllChannels(true)
      } else {
        this.selectedChannels = []
        this.setSelectedAllChannels(false)
      }
    }
  },

  created() {
    this.readPendingList()
  }
}
</script>

<style lang="scss">
.pending-table {

  .checkbox-channel .el-checkbox__label {
    display: none;
  }

  .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
  }

  .checkbox-channel {
    display: flex;

    span {
      width: 20px;
      height: 20px;
      border-color: #e55279;
    }
  }
}
</style>
